module.exports = __webpack_public_path__ + "img/logo.e399eb1d.svg";